import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4DeductibleArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'What Deductible Should I Choose for HO-4? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', 'Learn how to choose the best HO-4 deductible by balancing monthly premium and out-of-pocket risk.');
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/what-deductible-should-i-choose-for-ho4"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>What deductible should I choose for HO-4?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>Pick a deductible you can comfortably afford if a claim happens tomorrow.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4"><div className="card-body">
            <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
            <p>Lower deductibles usually mean higher monthly cost, while higher deductibles reduce premium but increase your out-of-pocket at claim time.</p>
            <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>Simple decision framework</h3>
            <ol style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>Set your emergency-cash comfort number.</li>
              <li style={{ marginBottom: '0.5rem' }}>Compare two deductible options side-by-side.</li>
              <li>Pick the option you can pay without financial strain.</li>
            </ol>
            <p style={{ marginTop: '1rem', marginBottom: 0 }}>
              Pair deductible decisions with <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>liability limits</Link> and overall <Link to="/knowledge-base/how-much-does-ho4-cost-in-texas" style={articleLinkStyle}>HO-4 pricing in Texas</Link>.
            </p>
          </div></article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>See deductible and premium options in one flow.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Want help deciding your deductible?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can help you choose a deductible that matches your risk tolerance.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4DeductibleArticlePage;

